// extracted by mini-css-extract-plugin
export default {"menu":"RegionManager_menu__t1znx","menuContent":"RegionManager_menuContent__y7kFG"};